import { render, staticRenderFns } from "./QMonthlySalesChart.vue?vue&type=template&id=2caa68f6&scoped=true&"
import script from "./QMonthlySalesChart.vue?vue&type=script&lang=js&"
export * from "./QMonthlySalesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa68f6",
  null
  
)

export default component.exports